module.exports = __webpack_public_path__ + "static/img/CAA.374c42a7.png";